exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".case-search__dialog{overflow-y:hidden;max-width:80% !important}", ""]);

